import type { HttpResponse } from "@/api/types";

export function commonAPIDataSelector<TData, TError = unknown>(response: HttpResponse<TData, TError>): TData {
  return response.data;
}
